import { Injectable } from "@angular/core";
import { HttpService } from "src/app/services/http.service";
import { TimelineEventDto } from 'src/app/features/events/events.models';
import { environment } from "src/environments/environment";

@Injectable()
export class EventsService {
    constructor(
        private http: HttpService,
    ) { }

    async getChangelogs(
        departmentId: string,
        days: number = 30,
        beforeTimeStamp?: Date,
        take: number = 100,
    ): Promise<TimelineEventDto[]> {
        const beforeQuery = beforeTimeStamp
            ? `&beforeTimeStamp=${encodeURIComponent(beforeTimeStamp.toISOString())}`
            : '';

        const response = await this.http.get<TimelineEventDto[]>(`${environment.adminConfig.apiUri}/timeline/query/Config/${departmentId}?take=${take}&days=${days}${beforeQuery}`);

        if (!Array.isArray(response)) {
            throw new Error('Invalid response');
        }

        return response;
    }

    async getLogGroupEvents(logGroup: string, days: number = 30): Promise<TimelineEventDto[]> {
        const response = await this.http.get<TimelineEventDto[]>(`${environment.adminConfig.apiUri}/timeline/group/${logGroup}?take=1000&days=${days}`);

        if (!Array.isArray(response)) {
            throw new Error('Invalid response');
        }

        return response;
    }
}